import type { Product } from "@omni/types/api/product/bff/product.model";
import type { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const EXCLUDE_HUBO_FOR_SLUGS = [
    "levis-ambiance-barbie",
    "levis-colour-futures-2026",
    "levis-colour-futures-2027"
];

const HUBO_BRAND = "Hubo_VA_MerkHubo";

const filter: (
    collection?: string
) => ModelMapper<
    Array<Product<ProductFieldSet.Full>>,
    Array<Product<ProductFieldSet.Full>>
> = (collection?: string) => (products) => {
    if (!collection || !EXCLUDE_HUBO_FOR_SLUGS.includes(collection)) {
        return products;
    }

    return products.filter(
        (product) =>
            product.brand?.code?.toLowerCase() !== HUBO_BRAND.toLowerCase()
    );
};

export const ProductFilters = {
    filter
};
